/*
  assets/gtender-workspace.js — GTENDER-WORKSPACE-FE-WS01
  Owner: /pages/gtender-dashboard Pro workspace navigation shell only.
  Boundary: no identity, plan, API, persistence, commerce, or capability-data ownership.
*/
(function () {
  'use strict';

  var VERSION = 'gtender-workspace-fe-ws01-01';
  var GLOBAL_KEY = '__GTENDER_WORKSPACE_RUNTIME__';
  var ROOT_SELECTOR = '[data-gtender-dashboard-root][data-native-session-required]';
  var CONTENT_SELECTOR = '[data-gtender-dashboard-content]';
  var SHELL_SELECTOR = '[data-gtender-workspace-shell]';
  var TAB_SELECTOR = '[data-gtender-workspace-tab]';
  var PANEL_SELECTOR = '[data-gtender-workspace-panel]';
  var TAB_KEYS = Object.freeze(['overview', 'saved', 'watch', 'pipeline', 'evidence']);
  var stateByRoot = new WeakMap();

  if (window[GLOBAL_KEY] && typeof window[GLOBAL_KEY].boot === 'function') {
    window[GLOBAL_KEY].boot(document);
    return;
  }

  function list(scope, selector) {
    return scope && scope.querySelectorAll ? Array.prototype.slice.call(scope.querySelectorAll(selector)) : [];
  }

  function isZh(root) {
    var locale = root && root.getAttribute('data-locale');
    return /^zh(?:-|$)/i.test(String(locale || document.documentElement.lang || navigator.language || ''));
  }

  function copy(root, zh, en) {
    return isZh(root) ? zh : en;
  }

  function label(root, key) {
    var labels = {
      overview: [copy(root, '總覽', 'Overview'), copy(root, '總覽', 'Overview')],
      saved: [copy(root, '雲端收藏', 'Saved'), copy(root, '雲端收藏', 'Saved tenders')],
      watch: [copy(root, '監察', 'Watch'), copy(root, '監察規則與提醒', 'Watch rules and alerts')],
      pipeline: ['Pipeline', copy(root, '投標機會 Pipeline', 'Opportunity pipeline')],
      evidence: ['Evidence', copy(root, '要求與 Evidence', 'Requirements and evidence')]
    };
    return labels[key];
  }

  function safeId(root, suffix) {
    var base = root && root.id ? root.id : 'gtender-dashboard';
    return base.replace(/[^A-Za-z0-9_-]/g, '-') + '-workspace-' + suffix;
  }

  function makeButton(root, key, selected) {
    var labels = label(root, key);
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'gtender-workspace__tab';
    button.setAttribute('data-global-breadcrumb-view', '');
    var tones = { overview: 'overview', saved: 'timeline', watch: 'portfolio', pipeline: 'profile', evidence: 'overview' };
    button.setAttribute('data-global-breadcrumb-tone', tones[key]);
    button.id = safeId(root, 'tab-' + key);
    button.setAttribute('role', 'tab');
    button.setAttribute('data-gtender-workspace-tab', key);
    button.setAttribute('aria-controls', safeId(root, 'panel-' + key));
    button.setAttribute('aria-selected', selected ? 'true' : 'false');
    button.setAttribute('aria-label', labels[1]);
    button.tabIndex = selected ? 0 : -1;
    button.textContent = labels[0];
    if (!selected) {
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
    }
    return button;
  }

  function makePanel(root, key, selected) {
    var panel = document.createElement('section');
    panel.className = 'gtender-workspace__panel';
    panel.id = safeId(root, 'panel-' + key);
    panel.setAttribute('role', 'tabpanel');
    panel.setAttribute('data-gtender-workspace-panel', key);
    panel.setAttribute('aria-labelledby', safeId(root, 'tab-' + key));
    if (!selected) panel.hidden = true;
    if (key !== 'overview') {
      var host = document.createElement('div');
      host.className = 'gtender-workspace__panel-host';
      host.setAttribute('data-gtender-workspace-panel-host', key);
      panel.appendChild(host);
    }
    return panel;
  }

  function enabledTabs(root) {
    return list(root, TAB_SELECTOR).filter(function (tab) { return !tab.disabled; });
  }

  function select(root, key, options) {
    var state = stateByRoot.get(root);
    if (!state || TAB_KEYS.indexOf(key) < 0) return false;
    var tab = root.querySelector(TAB_SELECTOR + '[data-gtender-workspace-tab="' + key + '"]');
    if (!tab || tab.disabled) return false;

    list(root, TAB_SELECTOR).forEach(function (node) {
      var active = node === tab;
      node.setAttribute('aria-selected', active ? 'true' : 'false');
      node.tabIndex = active ? 0 : -1;
    });
    list(root, PANEL_SELECTOR).forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-gtender-workspace-panel') !== key;
    });
    root.setAttribute('data-workspace-tab', key);
    if (options && options.focus && typeof tab.focus === 'function') tab.focus();
    root.dispatchEvent(new CustomEvent('gtender-workspace:tabchange', {
      bubbles: true,
      detail: { tab: key }
    }));
    return true;
  }

  function enable(root, key) {
    var state = stateByRoot.get(root);
    if (!state || key === 'overview' || TAB_KEYS.indexOf(key) < 0) return false;
    var tab = root.querySelector(TAB_SELECTOR + '[data-gtender-workspace-tab="' + key + '"]');
    if (!tab) return false;
    tab.disabled = false;
    tab.removeAttribute('aria-disabled');
    root.dispatchEvent(new CustomEvent('gtender-workspace:enabled', {
      bubbles: true,
      detail: { tab: key }
    }));
    return true;
  }

  function disable(root, key) {
    var state = stateByRoot.get(root);
    if (!state || key === 'overview' || TAB_KEYS.indexOf(key) < 0) return false;
    var tab = root.querySelector(TAB_SELECTOR + '[data-gtender-workspace-tab="' + key + '"]');
    if (!tab) return false;
    if (tab.getAttribute('aria-selected') === 'true') select(root, 'overview');
    tab.disabled = true;
    tab.setAttribute('aria-disabled', 'true');
    tab.tabIndex = -1;
    return true;
  }

  function onClick(root, event) {
    var tab = event.target && event.target.closest ? event.target.closest(TAB_SELECTOR) : null;
    if (!tab || !root.contains(tab) || tab.disabled) return;
    select(root, tab.getAttribute('data-gtender-workspace-tab'), { focus: true });
  }

  function onKeydown(root, event) {
    var current = event.target && event.target.closest ? event.target.closest(TAB_SELECTOR) : null;
    if (!current || !root.contains(current) || current.disabled) return;
    var tabs = enabledTabs(root);
    if (!tabs.length) return;
    var index = tabs.indexOf(current);
    var next = null;
    if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
    else if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
    else if (event.key === 'Home') next = tabs[0];
    else if (event.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    event.preventDefault();
    select(root, next.getAttribute('data-gtender-workspace-tab'), { focus: true });
  }

  function restore(state) {
    if (!state) return;
    if (state.stats && state.statsMarker && state.statsMarker.parentNode) {
      state.statsMarker.parentNode.insertBefore(state.stats, state.statsMarker);
      state.statsMarker.remove();
    }
    if (state.grid && state.gridMarker && state.gridMarker.parentNode) {
      state.gridMarker.parentNode.insertBefore(state.grid, state.gridMarker);
      state.gridMarker.remove();
    }
  }

  function mount(root) {
    if (!root || stateByRoot.has(root)) return;
    var content = root.querySelector(CONTENT_SELECTOR);
    if (!content || content.querySelector(SHELL_SELECTOR)) return;
    var hero = content.querySelector('.gtender-dashboard__hero');
    var stats = content.querySelector('.gtender-dashboard__stats');
    var grid = content.querySelector('.gtender-dashboard__grid');
    if (!hero || !stats || !grid) return;

    var state = {
      controller: new AbortController(),
      shell: null,
      stats: stats,
      grid: grid,
      statsMarker: document.createComment('gtender-workspace-stats'),
      gridMarker: document.createComment('gtender-workspace-grid')
    };
    stateByRoot.set(root, state);

    stats.parentNode.insertBefore(state.statsMarker, stats);
    grid.parentNode.insertBefore(state.gridMarker, grid);

    var shell = document.createElement('section');
    shell.className = 'gtender-workspace';
    shell.setAttribute('data-gtender-workspace-shell', '');
    shell.setAttribute('data-workspace-version', VERSION);
    shell.setAttribute('aria-label', copy(root, 'GTender Pro 工作區', 'GTender Pro workspace'));

    var tabs = document.createElement('div');
    tabs.className = 'gtender-workspace__tabs';
    tabs.setAttribute('data-global-breadcrumb-items', 'scroll');
    tabs.setAttribute('role', 'tablist');
    tabs.setAttribute('aria-label', copy(root, '工作區分頁', 'Workspace tabs'));

    var body = document.createElement('div');
    body.className = 'gtender-workspace__body';

    TAB_KEYS.forEach(function (key, index) {
      tabs.appendChild(makeButton(root, key, index === 0));
      body.appendChild(makePanel(root, key, index === 0));
    });

    var overview = body.querySelector(PANEL_SELECTOR + '[data-gtender-workspace-panel="overview"]');
    overview.appendChild(stats);
    overview.appendChild(grid);
    shell.appendChild(tabs);
    shell.appendChild(body);
    hero.insertAdjacentElement('afterend', shell);
    state.shell = shell;
    root.setAttribute('data-workspace-owner', VERSION);
    root.setAttribute('data-workspace-tab', 'overview');

    shell.addEventListener('click', function (event) { onClick(root, event); }, { signal: state.controller.signal });
    shell.addEventListener('keydown', function (event) { onKeydown(root, event); }, { signal: state.controller.signal });
    root.addEventListener('gtender-dashboard:access-invalidated', function () { select(root, 'overview'); }, { signal: state.controller.signal });
  }

  function getPanelHost(root, key) {
    if (!stateByRoot.has(root) || TAB_KEYS.indexOf(key) < 0 || key === 'overview') return null;
    return root.querySelector('[data-gtender-workspace-panel-host="' + key + '"]');
  }

  function destroy(root) {
    var state = root ? stateByRoot.get(root) : null;
    if (!state) return;
    state.controller.abort();
    restore(state);
    if (state.shell && state.shell.isConnected) state.shell.remove();
    root.removeAttribute('data-workspace-owner');
    root.removeAttribute('data-workspace-tab');
    stateByRoot.delete(root);
  }

  function boot(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) mount(target);
    list(target, ROOT_SELECTOR).forEach(mount);
  }

  function destroyAll(scope) {
    var target = scope || document;
    if (target.matches && target.matches(ROOT_SELECTOR)) destroy(target);
    list(target, ROOT_SELECTOR).forEach(destroy);
  }

  document.addEventListener('shopify:section:load', function (event) { boot(event.target || document); });
  document.addEventListener('shopify:section:unload', function (event) { destroyAll(event.target || document); });

  var api = Object.freeze({
    version: VERSION,
    tabs: TAB_KEYS.slice(),
    boot: boot,
    destroy: destroyAll,
    enable: enable,
    disable: disable,
    select: select,
    getPanelHost: getPanelHost
  });
  window[GLOBAL_KEY] = api;
  window.GTenderWorkspace = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); }, { once: true });
  } else {
    boot(document);
  }
})();
